$(document).ready(function() {
	if ($('.scroll-nav-wrapper').length) {
		var lastScrollTop = 0;
		
		$(window).scroll(function() {
			var scrollPos = $(window).scrollTop();
			var headerHeight = $('header#header').height();
			var desktopMenuScroll =
				$('.scroll-nav-wrapper').offset().top -
				$('#desktopMenu').height();
			if (scrollPos >= desktopMenuScroll) {
				$('#desktopMenu').addClass('stickyMenu');
				
				if (scrollPos > lastScrollTop){
					$('#desktopMenu').css('top', '0');
				} else {
					$('#desktopMenu').css('top', headerHeight);
				}
				lastScrollTop = scrollPos;
			} else {
				$('#desktopMenu').removeClass('stickyMenu');
			}
		});

		var lastScrollTopM = 0;
		
		$(window).scroll(function() {
			var scrollPos = $(this).scrollTop();
			var headerHeight = $('header#header').height();
			var mobileMenuScroll =
				$('.scroll-nav-wrapper').offset().top -
				$('#mobileMenu').height();

			if (scrollPos >= mobileMenuScroll) {
				$('#mobileMenu').addClass('stickyMenu');

				if (scrollPos > lastScrollTopM){
					$('#mobileMenu').css('top', '0');
				} else {
					$('#mobileMenu').css('top', headerHeight);
				}
				lastScrollTopM = scrollPos;

			} else {
				$('#mobileMenu').removeClass('stickyMenu');
				$('#mobileMenu').removeAttr('style');
			}
		});
	}
});
